export const validateCnae = (cep: string): boolean => {
    // Verifica se o CEP possui 8 dígitos
    if (cep.length !== 7) {
        return false
    }

    if (cep === '0000000') {
        return false
    }

    return true;
}